import React, { useCallback, useEffect, useRef, useState } from 'react';
import { gbApi, gbError } from './gbApi';
import { GbDuelLoader } from './GbDuelLoader';

const GB_GAME_VERSION = '20260620cor11';  // troque ao editar gbarena.html (evita cache velho)

export const GbBattle = ({ match, player, node, clan, avatarUrl, onItemUsed, onFinished, onClose,
  pvp, pvpRef, onPvpSend }) => {
  const frameRef = useRef(null);
  const sentRef = useRef(false);
  const [pct, setPct] = useState(6);
  const [loading, setLoading] = useState(true);
  const [frameOn, setFrameOn] = useState(false);

  const post = useCallback((type, payload) => {
    frameRef.current?.contentWindow?.postMessage({ type, payload }, window.location.origin);
  }, []);

  // o iframe só monta depois que a tela cheia/paisagem assenta: o jogo nasce já no tamanho da tela
  useEffect(() => {
    const t = setTimeout(() => setFrameOn(true), 450);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!loading) return;
    const t = setInterval(() => setPct((v) => (v < 12 ? v + 2 : v)), 120);
    return () => clearInterval(t);
  }, [loading]);

  useEffect(() => {
    const handler = async (ev) => {
      if (ev.origin !== window.location.origin) return;
      const data = ev.data || {};
      if (data.source !== 'gb-arena') return;

      if (data.type === 'load') {
        setPct((v) => Math.max(v, 12 + Math.round(Number(data.payload || 0) * 80)));
        return;
      }

      if (data.type === 'ready') {
        setPct(100);
        setTimeout(() => setLoading(false), 500);
        if (pvp) { post('gb:start', pvp); return; }
        post('gb:start', {
          match_id: match.match_id,
          node: match.node,
          node_name: node?.name || `Fase ${match.node}`,
          map: match.map,
          bot_hp: match.bot_hp,
          bot_accuracy: match.bot_accuracy,
          wind_max: match.wind_max,
          traps: match.traps,
          cost: match.cost,
          terrain_seed: match.terrain_seed,
          features: match.features || [],
          upgrades: player?.upgrades || {},
          items: player?.items || {},
          opponent: match.opponent || null,
          player: { nickname: player?.nickname || 'Você', avatar: avatarUrl || '',
            color: clan?.hex || '', clan: clan?.name || '',
            clan_name: clan?.name || '', medal_img: clan?.medal_img || '' },
        });
      }

      if (data.type === 'pvp') { onPvpSend?.(data.payload || {}); return; }

      if (data.type === 'item') {
        // item de batalha é consumível: sai do inventário no servidor na hora do uso
        try {
          const res = await gbApi.post('/items/use', {
            match_id: match?.match_id || '', kind: (data.payload || {}).kind,
          });
          post('gb:item', res.data);
          onItemUsed?.(res.data);
        } catch (e) { post('gb:item', { error: gbError(e) }); }
        return;
      }

      if (data.type === 'result') {
        if (sentRef.current) return;
        sentRef.current = true;
        const r = data.payload || {};
        try {
          const res = await gbApi.post('/mission/finish', {
            match_id: match.match_id,
            token: match.token,
            won: !!r.won,
            duration: Number(r.duration || 0),
            shots: Number(r.shots || 0),
            damage: Number(r.damage || 0),
            hp_left_pct: Number(r.hp_left_pct || 0),
            items_used: r.items_used || {},
          });
          post('gb:reward', res.data);
          onFinished?.(res.data);
        } catch (e) {
          post('gb:reward', { error: gbError(e) });
          onFinished?.(null);
        }
      }

      if (data.type === 'exit') onClose?.();
    };
    window.addEventListener('message', handler);
    if (pvpRef) pvpRef.current = post;
    return () => {
      window.removeEventListener('message', handler);
      if (pvpRef) pvpRef.current = null;
    };
  }, [match, node, player, clan, avatarUrl, post, onFinished, onClose, pvp, pvpRef, onPvpSend]);

  const eu = pvp?.player || { nickname: player?.nickname || 'Você', avatar: avatarUrl || '',
    clan_name: clan?.name || '', medal_img: clan?.medal_img || '' };
  const rival = pvp?.opponent || match?.opponent || node?.opponent || null;

  return (
    <div className="pwa-safe-top fixed inset-0 z-[75] bg-[#0b0712]" data-testid="gb-battle-overlay">
      {frameOn && (
        <iframe
          ref={frameRef}
          title="GB Arena"
          src={`/gbarena.html?v=${GB_GAME_VERSION}`}
          className="h-full w-full border-0"
          allow="autoplay"
        />
      )}
      {loading && (
        <GbDuelLoader pct={pct} eu={eu} rival={rival}
          titulo={pvp ? (pvp.mode === 'spec' ? 'ASSISTINDO AO VIVO' : 'PVP AO VIVO')
            : (node?.name || `Fase ${match?.node}`)} />
      )}
    </div>
  );
};
